import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import ContestEditForm, {IContestEditForm} from '../../../components/Contest/EditForm';
import UseContest, {ContestType} from '../../../hooks/apis/useContest';
import {Breadcrumb, Card, Divider, message} from 'antd';
import QuickRouter from '../../../utils/QuickRouter';
import CollectionWorkEditForm from '../../../components/CollectionWork/EditForm';
import useAuth from '../../../utils/AuthContext';
import {useMount} from 'react-use';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useQuickRouter from '../../../utils/QuickRouter';
import KnowLedgeTestManage from '../../../components/KnowledgeTest/Manage';
import {useParams} from 'react-router-dom';

export default function ManageContestEditPage() {
  const auth = useAuth();
  const saveState = UseContest.save();
  const queryById = UseContest.queryById();
  const contest = queryById.data;
  const params = useParams() as {id?: string};
  const routeQueryId = params?.id || '';
  const quickRouter = useQuickRouter();

  function refresh() {
    queryById
      .request({
        id: parseInt(routeQueryId as string),
      })
      .then()
      .catch(CommonApiErrorHandler);
  }

  function save(form: IContestEditForm) {
    saveState
      .request(form)
      .then(() => {
        message.success('操作成功');
        refresh();
      })
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Breadcrumb className={'mb-md'}>
        <Breadcrumb.Item>
          <a onClick={quickRouter.index}>首页</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a onClick={quickRouter.manageContestList}>活动列表</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card title={'活动编辑: ' + queryById.data?.name}>
        <ContestEditForm form={queryById.data ? {...queryById.data} : undefined} isLoading={saveState.loading} onFinish={save} />
        {contest && contest.type === ContestType.知识竞赛类 && (
          <React.Fragment>
            <Divider>答题演练设置</Divider>
            <KnowLedgeTestManage testId={contest.simulationKnowledgeTestId} />
            <Divider>正式答题设置</Divider>
            <KnowLedgeTestManage testId={contest.regulationKnowledgeTestId} />
          </React.Fragment>
        )}
        {queryById.data?.type === ContestType.作品征集类 && (
          <>
            <Divider>作品征集设置</Divider>
            <CollectionWorkEditForm collectionWork={queryById.data.collectionWork} />
          </>
        )}
      </Card>
    </div>
  );
}
